export enum GatewayCommunicationRequestNames {
  I_CONN_UNIVERSAL = 'iConn_Universal',
  HELIX_UNIVERSAL = 'Helix_Universal'
}

export enum GatewayCommunicationRequestTypes {
  COMMAND = 'Command',
  CONFIGURATION = 'Configuration'
}